import React, { useContext } from 'react';
import { CollectionSettingsIntegrationContext, CollectionSettingsPageDispatchContext } from '../contextProvider';
import ConnectDataNotion from './notion';
import { ICollectionIntegration } from '../../../../../types';
import { SETTINGS_PAGE } from '../constants';

function ConnectData() {
  const integration = useContext(CollectionSettingsIntegrationContext);

  const setSettingsPage = useContext(CollectionSettingsPageDispatchContext);

  const onGoNext = () => {
    setSettingsPage(SETTINGS_PAGE.CONNECT_TABLE);
  };

  const INTEGRATION_COMPONENT = {
    [ICollectionIntegration.NOTION]: <ConnectDataNotion onGoNext={onGoNext} />,
  };
  return INTEGRATION_COMPONENT[integration];
}

export default ConnectData;
